import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal } from "../../../../../components/modal";
import { FormContainer } from "./style";
import DatePicker from "../../../../../components/datepicker";
import ExpandHeightTextarea from "../../../../../components/expandHeightTextarea";
import { Confirm } from "../../../../../components/confirm";
import { PettyCashierPettyCashAction } from "../../../../../actions";
import {
  CONFIRM_ACCEPT_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT,
  SELECT_DATE_ISSUE_WARNING,
  WARNING_SINGLE_BUTTON_TEXT
} from "../../../../../constants/otherTexts";

const START_DATE = "start_date";
const END_DATE = "end_date";
const DESCRIPTION = "description";
const PrintInfo = props => {
  const { modalData: values, modalStatus, closeModal, processing } = props;
  const [dateProblemConfirm, toggleDateProblemConfirm] = useState(false);
  const [startDate, changeStartDate] = useState(values[START_DATE]);
  const [endDate, changeEndDate] = useState(values[END_DATE]);
  const [description, changeDescription] = useState(values[DESCRIPTION]);

  useEffect(() => {
    if (modalStatus) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      changeDescription("");
      changeEndDate(null);
      changeStartDate(null);
      document.body.style.overflow = "auto";
    };
  }, [modalStatus]);

  useEffect(() => {
    changeStartDate(values[START_DATE]);
    changeEndDate(values[END_DATE]);
    changeDescription(values[DESCRIPTION]);
  }, [values]);

  const submit = () => {
    if (startDate <= endDate) {
      props.updateInfo(values.id, {
        [START_DATE]: startDate,
        [END_DATE]: endDate,
        [DESCRIPTION]: description
      });
    } else {
      toggleDateProblemConfirm(true);
    }
  };

  return (
    <React.Fragment>
      <Confirm
        content={{
          type: "warning",
          message: SELECT_DATE_ISSUE_WARNING,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
        }}
        show={dateProblemConfirm}
        rejectHandler={() => {
          toggleDateProblemConfirm(false);
        }}
        close={() => {
          toggleDateProblemConfirm(false);
        }}
      />
      <Modal
        show={modalStatus}
        height={"60vh"}
        loading={processing}
        closeHandler={() => closeModal()}
        header={{
          title: "تنظیمات چاپ",
          icon: "icon mapsa-configuration",
          iconColor: "primary_vivid"
        }}
        footer={{
          buttons: [
            {
              buttonType: "primary",
              clickHandler: () => submit(),
              buttonText: CONFIRM_ACCEPT_BUTTON_TEXT,
              useLoading: true
            },
            {
              buttonType: "secondary",
              clickHandler: () => closeModal(),
              buttonText: CONFIRM_REJECT_BUTTON_TEXT
            }
          ]
        }}
      >
        <FormContainer>
          <div className="extra-note">
            در این قسمت می‌توانید دوره تنخواه و توضیحات مربوط به آن که در نسخه
            چاپی قابل مشاهده است، را تنظیم کنید.
          </div>
          <div className="flex date-box">
            <i className="icon mapsa-watch side-icon" />
            <div>
              <label>تاریخ شروع</label>
              <DatePicker
                input={{
                  value: startDate,
                  onChange: value => {
                    changeStartDate(value);
                  }
                }}
                meta={{}}
              />
            </div>
            <i className="icon mapsa-back-1 side-icon arrow" />
            <div>
              <label>تاریخ پایان</label>
              <DatePicker
                input={{
                  value: endDate,
                  onChange: value => {
                    changeEndDate(value);
                  }
                }}
                meta={{}}
              />
            </div>
          </div>
          <div className="flex">
            <i className="icon mapsa-description side-icon" />
            <div className="description">
              <ExpandHeightTextarea
                padding={"10px"}
                input={{
                  name: "description",
                  value: description,
                  onChange: value => changeDescription(value)
                }}
                meta={{}}
                status="normal"
                placeholder="توضیحات..."
              />
            </div>
          </div>
        </FormContainer>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = store => {
  return {
    processing: store.PettyCashierPettyCash.printInfoProcessing,
    modalStatus: store.PettyCashierPettyCash.printInfoModalStatus,
    modalData: store.PettyCashierPettyCash.printInfoModalData
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateInfo: (id, data) => {
      dispatch(PettyCashierPettyCashAction.updateInfo(id, data));
    },
    closeModal: () => {
      dispatch(PettyCashierPettyCashAction.printInfoCloseModal());
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PrintInfo)
);
